import { ReactNode, useState } from "react";
import Button from "../form-control/Button";

interface IProps {
    onClose: () => void;
    onConfirm: () => void;
    resourceName?: string;
    resourceType?: string;
    confirmationMessage?: ReactNode;
    title?: string;
}

const ActionConfirmation = (props: IProps): JSX.Element => {
    const [submitting, setSubmitting] = useState<boolean>(false);

    return (
        <div className="py-[43px] px-0 md:px-6 w-full">
            <h3 className="w-full text-center font-headings text-[20px] pb-6 dark:text-text-dark-primary">{props.title ?? "Confirm"}</h3>
            {props.confirmationMessage ? (
                <p className="dark:text-text-dark-primary">
                    {props.confirmationMessage}
                </p>
            ) : (
                <p className="w-full text-center dark:text-text-dark-primary">
                    Are you sure you want to delete {props.resourceType} <b>{props.resourceName}</b>?. This action cannot be undone.
                </p>
            )}

            <div className="flex-col-reverse gap-5 flex md:flex-row  mt-10 ">
                <div className="w-full md:w-1/2">
                    <Button
                        label="Cancel"
                        onClick={props.onClose}
                        curved
                        className=" w-full px-[12px] py-[12px] h-[45px] dark:bg-primary-dark-secondary rounded border border-primary-border dark:border-primary-dark-border_active hover:bg-primary-main hover:text-white dark:text-text-dark-primary"
                    />
                </div>

                <div className="w-full md:w-1/2">
                    <Button
                        label="Confirm"
                        className="w-full px-[12px] py-[12px] h-[45px] rounded border border-primary-border hover:bg-white text-white hover:text-primary-main hover:border-primary-main"
                        onClick={() => {
                            setSubmitting(true);
                            props.onConfirm()
                        }}
                        curved
                        bgColor="primary"
                        disabled={submitting}
                        loading={submitting}
                    />
                </div>
            </div>
        </div>
    )
}

export default ActionConfirmation;